import { useRef, useEffect, useState } from 'react';

const Sidebar = ({
	sidebarOpen,
	setSidebarOpen,
	chatIds,
	currentChatIndex,
	handleSelectChat,
	handleNewChat,
	visibleChatCount,
	isLoadingMoreChats,
	handleSidebarScroll,
	user,
	firstQueries
}) => {
	const listRef = useRef(null);

	useEffect(() => {
		if (visibleChatCount >= chatIds.length && listRef.current) {
			listRef.current.scrollTop = listRef.current.scrollHeight;
		}
	}, [visibleChatCount, chatIds.length]);

	const onOpenNewChatClick = () => {
		handleNewChat();
		if (!sidebarOpen)
			setSidebarOpen(true);
		listRef.current.scrollTop = listRef.current.scrollHeight;
	};

	const [profileOpen, setProfileOpen] = useState(false);
	const profileRef = useRef(null);

	const handleProfileToggle = () => setProfileOpen((p) => !p);

	const handleLogout = () => {
		setProfileOpen(false);		
		localStorage.removeItem('token');
		localStorage.removeItem('user_id');
		sessionStorage.removeItem("token_checked");
		sessionStorage.removeItem("user_data");
		window.location.href = '/login';		
	};

	useEffect(() => {
		if (!profileOpen) return;
		function handleClickOutside(e) {
			if (profileRef.current && !profileRef.current.contains(e.target) && !e.target.closest('.user-profile')) {
				setProfileOpen(false);
			}
		}
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [profileOpen]);
	
	return (
		<div
			className={(sidebarOpen ? '' : 'collapsed') + " sidebar"}
			style={{ position: 'relative' }}
		>
			{/* <div className="sidebar-toggle">
        <button className="menu-btn" onClick={() => setSidebarOpen(false)}>☰</button>
      </div> */}

			<div className='user-profile' onClick={handleProfileToggle} style={{ cursor: 'pointer' }}>
				<span>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M8 0C5.67378 0 3.78125 1.89253 3.78125 4.21875C3.78125 6.54497 5.67378 8.4375 8 8.4375C10.3262 8.4375 12.2188 6.54497 12.2188 4.21875C12.2188 1.89253 10.3262 0 8 0ZM13.2489 11.1936C12.0939 10.0208 10.5628 9.375 8.9375 9.375H7.0625C5.43725 9.375 3.90606 10.0208 2.75106 11.1936C1.60172 12.3606 0.96875 13.901 0.96875 15.5312C0.96875 15.7901 1.17862 16 1.4375 16H14.5625C14.8214 16 15.0312 15.7901 15.0312 15.5312C15.0312 13.901 14.3983 12.3606 13.2489 11.1936Z" fill="#014A3F" />
					</svg>
				</span>
				<span className={sidebarOpen ? '' : 'display-none'}>{user?.full_name}</span>
			</div>

			{profileOpen && (
				<div ref={profileRef} className='profile-popup' style={{minWidth: sidebarOpen ? '220px' : '160px'}}>
					<div className='user-name'>{user?.full_name}</div>
					<div className='user-email'>{user?.email}</div>
					<button className='log-out' type='button' onClick={handleLogout}>خروج</button>
				</div>
			)}
			<div className='open-new-chat' onClick={onOpenNewChatClick}>
				<span>
					<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M10.0002 0.714966C15.1152 0.714966 19.2852 4.87747 19.2852 9.99997C19.2852 11.7775 18.7902 13.48 17.8527 14.9575L19.2252 18.25C19.3302 18.505 19.2852 18.805 19.1052 19.0225C18.9627 19.1875 18.7527 19.285 18.5352 19.285C18.4752 19.285 18.4152 19.2775 18.3627 19.2625L14.1627 18.295C12.8802 18.9475 11.4477 19.285 10.0002 19.285C4.87766 19.285 0.715157 15.1225 0.715157 9.99997C0.715157 4.87747 4.87766 0.714966 10.0002 0.714966ZM7.00015 10.75H9.25016V13C9.25016 13.4125 9.58766 13.75 10.0002 13.75C10.4127 13.75 10.7502 13.4125 10.7502 13V10.75H13.0002C13.4127 10.75 13.7502 10.4125 13.7502 9.99997C13.7502 9.58747 13.4127 9.24997 13.0002 9.24997H10.7502V6.99997C10.7502 6.58747 10.4127 6.24997 10.0002 6.24997C9.58766 6.24997 9.25016 6.58747 9.25016 6.99997V9.24997H7.00015C6.58765 9.24997 6.25015 9.58747 6.25015 9.99997C6.25015 10.4125 6.58765 10.75 7.00015 10.75Z" fill="#014A3F" />
					</svg>
				</span>
				<span className={sidebarOpen ? '' : 'display-none'}>شروع چت جدید</span>
			</div>
			<div className='search-chats'>
				<span>
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z" fill="#014A3F" />
						<path d="M21.3001 22.0001C21.1201 22.0001 20.9401 21.9301 20.8101 21.8001L18.9501 19.9401C18.6801 19.6701 18.6801 19.2301 18.9501 18.9501C19.2201 18.6801 19.6601 18.6801 19.9401 18.9501L21.8001 20.8101C22.0701 21.0801 22.0701 21.5201 21.8001 21.8001C21.6601 21.9301 21.4801 22.0001 21.3001 22.0001Z" fill="#014A3F" />
					</svg>
				</span>
				<span className={sidebarOpen ? '' : 'display-none'}>جست‌وجوی پیام مورد نظر</span>
			</div>
			<div className='chat-history'>
				<ul ref={listRef} onScroll={handleSidebarScroll} className={sidebarOpen ? '' : 'display-none'}>
					{chatIds.slice(0, visibleChatCount).map((chatId, index) => (
						<li
							key={chatId}
							className={index === currentChatIndex ? 'active' : ''}
							onClick={() => handleSelectChat(index) }
						>
							{ firstQueries[index] }
						</li>
					))}
					{isLoadingMoreChats && (
						<li className="loading">در حال بارگذاری…</li>
					)}
					{/* {visibleChatCount >= chatIds.length && (
            <li className="end-of-list">— انتهای لیست —</li>
          )} */}
				</ul>
				{/* <button className="logout-btn" onClick={onLogout}>خروج</button> */}
			</div>
		</div>
	);
};

export default Sidebar;